import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { KollabHRFullLogo } from '@gokrew/ui/assets';
import LanguageSwitcher from '@gokrew/ui/components/LanguageSwitcher';
import { setIntentionalLanguage } from '@gokrew/ui/utility/intentional-language';
import { BrandPanel } from '../BrandPanel';
import styles from './AuthSplitLayout.module.css';

interface AuthSplitLayoutProps {
  children: ReactNode;
}

/**
 * Split auth shell — branded panel on the left (desktop only) and a centered
 * form column on the right. The brand panel collapses on small screens, where
 * the logo drops into the form column's top bar instead.
 */
export const AuthSplitLayout = ({ children }: AuthSplitLayoutProps) => {
  return (
    <div className={styles.shell}>
      <div className={styles.brandCol}>
        <BrandPanel />
      </div>

      <div className={styles.formCol}>
        <div className={styles.topBar}>
          <Link to="/login" className={styles.mobileLogoLink}>
            <img
              src={KollabHRFullLogo}
              alt="KollabHR"
              className={styles.mobileLogo}
            />
          </Link>
          <div className={styles.langWrap}>
            <LanguageSwitcher onLanguageChange={setIntentionalLanguage} />
          </div>
        </div>

        <div className={styles.formInner}>
          <div className={styles.formCard}>{children}</div>
        </div>
      </div>
    </div>
  );
};
